import {Current} from '../current'
import {PageService} from '../../../extensions/page-service'

export const browserInitCurrent = () => {
  Current.init(
    PageService.getCurrentBoard,
    PageService.getCurrentProject,
    PageService.addLocationListener,
    PageService.removeLocationListener
  )
}
